import type { IPublicClientApplication } from "@azure/msal-browser";
import {
  appRedirectUri,
  authBridgeUri,
  framedAuth,
  loginRequest,
} from "./config";

export function startLogin(instance: IPublicClientApplication): void {
  void (framedAuth
    ? instance.loginPopup(loginRequest)
    : instance.loginRedirect({ ...loginRequest, redirectUri: appRedirectUri }));
}

export function startLogout(instance: IPublicClientApplication): void {
  void (framedAuth
    ? instance.logoutPopup({ postLogoutRedirectUri: authBridgeUri })
    : instance.logoutRedirect());
}
